export const TYPE_APPOINTMENTS = "APPOINTMENTS";
export const TYPE_SURVEY = "SURVEY";
export const TYPE_MOBILE = "MOBILE";
